module.exports = __webpack_public_path__ + "assets/img/script_base.76cdbe4d.jpg";